import { createSelector } from 'reselect';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import resolveMetricsConfig from '../../../../helpers/reportMetrics';

const location = (state) => state.routing?.location || state.routing?.locationBeforeTransitions || { query: {} };
const report = (state) => state.serverStorage?.store?.report || {};
const parameters = (state) => state.statistics.data.parameters || {};
const reportUtils = ReportComponent.utils;

const buildMetricsConfig = (parameters = {}, location = {}, reportMetricsValue = '') =>
    resolveMetricsConfig(parameters, location, reportMetricsValue, reportUtils);

export const getCheckedKeys = createSelector(
    parameters,
    location,
    report,
    (parameters, location, report) => {
        return buildMetricsConfig(parameters, location, report?.metrics).keys;
    }
);

export const getMetrics = createSelector(
    parameters,
    location,
    report,
    (parameters, location, report) => {
        return buildMetricsConfig(parameters, location, report?.metrics).binary;
    }
);

export const mainSelector = createSelector(
    report,
    (report) => {
        return reportUtils.getMultiLevelHeaderNames();
    }
);
